const SCROLL_ANIMATION_TRIGGER_CLASSNAME = "scroll-trigger";
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = "scroll-trigger--offscreen";
const SCROLL_ANIMATION_CANCEL_CLASSNAME = "scroll-trigger--cancel";

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      if (getComputedStyle(elementTarget).animationName === 'none') {
        window.sonicEntrances?.show(elementTarget);
        observer.unobserve(elementTarget);
        return;
      }
      if (!window.sonicEntrances?.start(elementTarget)) {
        observer.unobserve(elementTarget);
        return;
      }
      if (elementTarget.hasAttribute("data-cascade"))
        elementTarget.style.setProperty('--animation-order', index);
      observer.unobserve(elementTarget);
      elementTarget.addEventListener('animationend', () => window.sonicEntrances?.complete(elementTarget), { once: true });
    } else {
      if (element.target.dataset.sonicEntrance !== 'pending') return;
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

/**
 * Safe helper: returns a root that supports querySelectorAll.
 */
function getQueryRoot(rootEl) {
  if (rootEl && typeof rootEl.querySelectorAll === "function") return rootEl;
  return document;
}

function initializeScrollAnimationTrigger(
  rootEl = document,
  isDesignModeEvent = false,
) {
  const root = getQueryRoot(rootEl);

  const animationTriggerElements = Array.from(
    root.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME),
  );

  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add("scroll-trigger--design-mode");
    });
    return;
  }

  const nonStickyFooterSections = Array.from(
    document.querySelectorAll(".shopify-section-group-footer-group:not(.wt-footer-page-section)")
  );

  const elementsToObserve = [];

  animationTriggerElements.forEach((element) => {
    const inNonStickyFooter = nonStickyFooterSections.some((section) =>
      section.contains(element)
    );

    if (inNonStickyFooter) {
      element.classList.add(SCROLL_ANIMATION_CANCEL_CLASSNAME);
      window.sonicEntrances?.show(element);
    } else {
      elementsToObserve.push(element);
    }
  });

  if (elementsToObserve.length === 0) return;

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: "0px 0px -50px 0px",
  });
  elementsToObserve.forEach((element) => observer.observe(element));
}

window.addEventListener("DOMContentLoaded", () => {
  initializeScrollAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) =>
    initializeScrollAnimationTrigger(event.target, true),
  );
  document.addEventListener("shopify:section:reorder", () =>
    initializeScrollAnimationTrigger(document, true),
  );
}
